import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles"
import People from '@material-ui/icons/People'

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 280,
        backgroundColor: '#101A26'
    },
    dense: {
        marginTop: theme.spacing(2),
    },
    menu: {
        width: 200,
    }
}))

export default function SelectedFollower(props) {
    const {selectedUser} = props

    return (
    <div className={"wizardSectionContainer"}>
        <div className={"wizardTitle"}>
            <span className={"wizardTitleIcon"}><People/></span> Follower
        </div>
        <div style={{marginLeft: "1.6rem", marginTop: "0.6rem", fontSize: "1.1rem", fontWeight: "bold"}}>
            {selectedUser.firstName} {selectedUser.lastName}
        </div>
    </div>)
}
